module.exports = __webpack_public_path__ + "assets/ddacf04a29ff5a83cd50ed63d72017a8.mp3";